/** 文件清冊輪詢比對。只看清單上會顯示的欄位；伺服器回傳順序不同不算變更。 */

export function libraryItemSignature(item) {
  const eng = item?.engines?.oda || {};
  const meta = item?.meta || {};
  const scan = item?.package?.scan || {};
  return [
    item?.id ?? '',
    item?.name ?? '',
    item?.size ?? '',
    item?.folderId ?? '',
    item?.projectId ?? '',
    item?.addedAt ?? '',
    item?.shareActive ? 1 : 0,
    item?.isCurrent === false ? 0 : 1,
    item?.revisionCount ?? '',
    item?.missing ? 1 : 0,
    meta.drawingNo ?? '',
    meta.title ?? '',
    meta.discipline ?? '',
    meta.revision ?? '',
    meta.status ?? '',
    meta.floor ?? '',
    eng.status ?? '',
    eng.at ?? '',
    eng.error ?? '',
    eng.hasSvg ? 1 : 0,
    eng.hasMesh3d ? 1 : 0,
    item.referencePending ? 1 : 0,
    item.referenceStatus ?? '',
    eng.referencesDirty ? 1 : 0,
    scan.status ?? '',
    scan.role ?? '',
    scan.xrefPending ? 1 : 0,
  ].join('\u001f');
}

export function libraryItemsChanged(next, prev) {
  const incoming = Array.isArray(next) ? next : [];
  const current = Array.isArray(prev) ? prev : [];
  if (incoming.length !== current.length) return true;
  const prevById = new Map(current.map((item) => [item.id, libraryItemSignature(item)]));
  return incoming.some((item) => prevById.get(item.id) !== libraryItemSignature(item));
}
